import { Container, Grid, Box } from "@mui/material";

import Select from "@/components/ph/Select";

import FormSection from "../../utils/FormSection";

import { mapOptions } from "../hooks/mapSelects";
import { useVehicleForm } from "../hooks/useVehicleForm";

const VehicleData = () => {
  const {
    vehicle,
    handleChange,
    handleBlur,
    getErrorMessage,
    isFieldInvalid,
  } = useVehicleForm();

  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}
      sx={{ mx: 0 }}>
      <FormSection title="DATOS DEL VEHÍCULO">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 12 }}>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid size={{ xs: 12 }}>
                <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                  <Select
                    isInvalid={isFieldInvalid("tipo")}
                    errorMessage={getErrorMessage("tipo")}
                    type="labeled"
                    label="Tipo de vehículo"
                    name="tipo"
                    onChange={handleChange("tipo")}
                    onBlur={handleBlur("tipo")}
                    options={mapOptions(vehicle.tipos)}
                    placeholder=""
                    resetOnOptionsChange={true}
                    required
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                  <Select
                    isInvalid={isFieldInvalid("modelo")}
                    errorMessage={getErrorMessage("modelo")}
                    type="labeled"
                    label="Modelo"
                    name="modelo"
                    onChange={handleChange("modelo")}
                    onBlur={handleBlur("modelo")}
                    options={mapOptions(vehicle.modelos)}
                    placeholder=""
                    resetOnOptionsChange={true}
                    required
                  />
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                  <Select
                    isInvalid={isFieldInvalid("marca")}
                    errorMessage={getErrorMessage("marca")}
                    type="labeled"
                    label="Marca"
                    name="marca"
                    onChange={handleChange("marca")}
                    onBlur={handleBlur("marca")}
                    options={mapOptions(vehicle.marcas)}
                    placeholder=""
                    resetOnOptionsChange={true}
                    required
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                  <Select
                    isInvalid={isFieldInvalid("subMarca")}
                    errorMessage={getErrorMessage("subMarca")}
                    type="labeled"
                    label="Submarca"
                    name="subMarca"
                    onChange={handleChange("subMarca")}
                    onBlur={handleBlur("subMarca")}
                    options={mapOptions(vehicle.subMarcas)}
                    placeholder=""
                    resetOnOptionsChange={true}
                    required
                  />
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                  <Select
                    isInvalid={isFieldInvalid("descripcion")}
                    errorMessage={getErrorMessage("descripcion")}
                    type="labeled"
                    label="Descripción"
                    name="descripcion"
                    onChange={handleChange("descripcion")}
                    onBlur={handleBlur("descripcion")}
                    options={mapOptions(vehicle.descripciones)}
                    placeholder=""
                    resetOnOptionsChange={true}
                    required
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </FormSection>
    </Container>
  );
};

export default VehicleData;
